import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Panel, PanelGroup } from "rsuite";
import img from '../../assets/faq-illustration.png'
import { useState } from "react";
import { LucideMinus, LucidePlus } from "lucide-react";
const Faq = () => {
  const faqData = [
  {
    title: "What is Lorem Ipsum?",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
  },
  {
    title: "How does it work?",
    content: "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  },
  {
    title: "Is it secure?",
    content: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris."
  },
  {
    title: "How can I join?",
    content: "Duis aute irure dolor in reprehenderit in voluptate velit esse."
  },
  {
    title: "Do you offer support?",
    content: "Excepteur sint occaecat cupidatat non proident."
  }
];
  const { t } = useTranslation();
const [activeKey, setActiveKey] = useState(null); // clé du panel ouvert
//   const faqData = t("faq_data", { returnObjects: true });
//  return(<></>)


  faqData.sort(() => Math.random() - 0.5);

  const selectedFaqItems = faqData.slice(0, 4);
console.log('activekey',activeKey)
  return (
   <div className="" style={{ background: "#F5F5F5" }}>
     <div className="text-dark py-4 container-xl ">
      <div className="pt-5">
        <Row className="justify-content-between align-items-center">

        <Col lg="7" className="my-3">
          <div className="fs-4 fw-medium text-blue">{t("frequently_asked_questions")}</div>
          <p className="fs-6 my-3 fw-light">{t('faq_intro')}</p>
         <PanelGroup accordion activeKey={activeKey} onSelect={setActiveKey}>
  {selectedFaqItems.map((item, index) => {
    const isActive = activeKey === index; // on compare avec l'eventKey
    return (
      <div 
        key={index} 
        className={`shadow border border-2  mt-4 mb-5 rounded-5 p-3 ${isActive ? 'panel-border-blue' : 'border-white border-bottom-0'}`}
      >
        <Panel className="" eventKey={index} header={<div className="fw-medium ">{item.title}</div>}  caretAs={isActive ? LucideMinus : LucidePlus}>
          <p className="fs-6 fw-light">{item.content}</p>
        </Panel>
      </div>
    )
  })}
</PanelGroup>
        </Col>
        <Col md="6" lg="4" className="my-3">
          <div className="p-5 d-flex flex-column align-items-center gradient-blue text-white rounded-4">
            <img
              src={img}
              alt="illustration faq"
              width="260"
              height="260"
            />

            <div className="fs-4">{t('still_got_questions')}</div>
            <p className="opacity-75 mt-2 fs-5">{t('reach_out')}</p>

            <button className="bg-white bg-opacity-50 py-3 px-5 rounded mt-4">{t('contact_us')}</button>
          </div>

        </Col>
      </Row>
      </div>
    </div>
   </div>
  );
};
export default Faq;




